import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Grid, Typography } from '@mui/material';

import { BLACK } from '../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../theme/fontConstants';
import { CONTRACT_TYPES } from '../../../../../contracts/constants';

const Title = ({ text }) => (
  <Typography
    sx={{
      fontSize: '16px',
      color: BLACK[100],
      textTransform: 'none',
      fontFamily: PRIMARY_FONT[500],
    }}
  >
    {text}
  </Typography>
);

Title.propTypes = {
  text: PropTypes.string,
};

const Value = ({ text }) => (
  <Typography
    sx={{
      fontSize: '16px',
      color: BLACK[100],
      fontFamily: PRIMARY_FONT[300],
    }}
  >
    {text}
  </Typography>
);

Value.propTypes = {
  text: PropTypes.string,
};

const ContractCardRates = ({ contractType, transformedContract }) => {
  const isFixedRate = contractType === CONTRACT_TYPES.RATE_OVERRIDE;
  const isMarginRate = contractType === CONTRACT_TYPES.MARGIN_OVERRIDE;

  return (
    <Grid container spacing={8}>
      <Grid item display="flex" gap={1} flexDirection="column">
        <Grid item display="flex" gap={1}>
          <Title text={LanguageConverterV2('contractCard.startDate')} />
          <Value text={transformedContract?.startDate} />
        </Grid>
        <Grid item display="flex" gap={1}>
          <Title text={LanguageConverterV2('contractCard.expirationDate')} />
          <Value text={transformedContract?.endDate} />
        </Grid>
      </Grid>
      {isFixedRate && (
        <>
          <Grid item display="flex" gap={1} flexDirection="column">
            <Grid item display="flex" gap={1}>
              <Title text={LanguageConverterV2('contractCard.payRate')} />
              <Value text={transformedContract?.payRate} />
            </Grid>
            <Grid item display="flex" gap={1}>
              <Title text={LanguageConverterV2('contractCard.otPayRate')} />
              <Value text={transformedContract?.oTPayRate} />
            </Grid>
          </Grid>
          <Grid item display="flex" gap={1} flexDirection="column">
            <Grid item display="flex" gap={1}>
              <Title text={LanguageConverterV2('contractCard.billRate')} />
              <Value text={transformedContract?.billRate} />
            </Grid>
            <Grid item display="flex" gap={1}>
              <Title text={LanguageConverterV2('contractCard.otBillRate')} />
              <Value text={transformedContract?.oTBillRate} />
            </Grid>
          </Grid>
        </>
      )}
      {isMarginRate && (
        <Grid item display="flex" gap={1} flexDirection="column">
          <Grid item display="flex" gap={1}>
            <Title text={LanguageConverterV2('contractCard.regularMargin')} />
            <Value text={transformedContract?.payMargin} />
          </Grid>
          <Grid item display="flex" gap={1}>
            <Title text={LanguageConverterV2('contractCard.otMargin')} />
            <Value text={transformedContract?.oTPayMargin} />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

ContractCardRates.propTypes = {
  contractType: PropTypes.string,
  transformedContract: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    payRate: PropTypes.string,
    oTPayRate: PropTypes.string,
    billRate: PropTypes.string,
    oTBillRate: PropTypes.string,
    payMargin: PropTypes.string,
    oTPayMargin: PropTypes.string,
  }),
};

export default ContractCardRates;
